<div mat-dialog-title style="margin-bottom: 0px;">
  <div class="d-flex justify-content-between align-items-center">
    <h1 mat-dialog-title>{{ formMode
      ? (langObj?.AddTaskCheckList || ('AddTaskCheckList' | translate))
      : (langObj?.UpdateTaskCheckList || ('UpdateTaskCheckList' | translate))
      }}</h1>
    <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
      <i class="fa fa-times" style="color: #fff"></i>
    </button>
  </div>
</div>

<div class="d-flex align-items-center" style="margin-top:10px;">
  <button mat-mini-fab mat-button *ngIf="isAccess | permissionChecker" color="accent" (click)="addGroupModal()"
    [matTooltip]="langObj ? langObj?.AddGroup : ('AddGroup' | translate)" matTooltipClass="custom-tooltip"
    matTooltipPosition="above" style="display: flex; justify-content: center; align-items: center;">
    <i class="fa fa-plus" style="color: #fff"></i>
  </button>

  <button mat-mini-fab mat-button *ngIf="isAccess | permissionChecker" color="accent" (click)="addTable()"
    [matTooltip]="langObj ? langObj?.AddRow : ('AddRow' | translate)" type="button" matTooltipClass="custom-tooltip"
    matTooltipPosition="above"
    style="margin-left: 20px; background-color: #19ACAB; display: flex; justify-content: center; align-items: center;">
    <i class="fa fa-calendar-plus-o" style="color: #fff; vertical-align: initial;"></i>
  </button>
</div>

<div style="margin-top: 10px"></div>
<form [formGroup]="CheckListRowData">
  <table mat-table [dataSource]="CheckListAddModel" class="basic-table plant-model-table" matSort>
    <ng-container matColumnDef="itemActions">
      <th mat-header-cell *matHeaderCellDef>
        <p class="header-text">{{langObj ? langObj?.Action : ('Action' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index" class="row-action-btns-column">
        <div class="row-action-btns">
          <button mat-icon-button type="button" *ngIf="isDelete | permissionChecker" class="tree-view-btn"
            aria-label="View Row Tree" (click)="deleteRow(element, i)" matTooltip="Delete"
            matTooltipClass="custom-tooltip" matTooltipPosition="above">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                fill="#F85439" />
              <circle cx="17" cy="17" r="14" fill="#F85439" />
              <path
                d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                fill="white" />
            </svg>
          </button>
          <button mat-mini-fab mat-button type="button" color="primary" (click)="addDropDownModal(element,i)"
            matTooltip="{{langObj ? langObj?.AddDropdownElement : ('AddDropdownElement' | translate)}}"
            *ngIf="(element.displaybtn || element.itemtype==5) && isAccess | permissionChecker"
            matTooltipClass="custom-tooltip" matTooltipPosition="above">
            <i class="fa fa-plus" style="color: #fff;"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="items">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">{{langObj ? langObj?.Items : ('Items' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element">
        <!-- {{element.item}} -->
        <textarea matInput cdkTextareaAutosize (change)="columnEvent($event, element)"
          placeholder="{{langObj ? langObj?.Items : ('Items' | translate)}}" #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1" cdkAutosizeMaxRows="7">{{ element.item }}</textarea>

      </td>
    </ng-container>

    <ng-container matColumnDef="ListName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; padding-left: 0px">
        <p class="header-text">{{langObj ? langObj?.GroupName : ('GroupName' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-select name="drop" (selectionChange)="columnGroupEvent($event, element)" placeholder="Dropdown Group"
          value="{{ element.drop }}">
          <mat-option *ngFor="let data of GroupAdded" [value]="data">{{
            data
            }}</mat-option>
        </mat-select>
      </td>
    </ng-container>

    <ng-container matColumnDef="ItemType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;padding-left: 0px">
        <p class="header-text">{{langObj ? langObj?.ItemType : ('ItemType' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element;let i  = index"
        style="padding: 13px 0px; padding-right: 10px; padding-left: 10px;">
        <mat-select name="itemtype" (selectionChange)="columnItemEvent($event, element,i)"
          placeholder="{{langObj ? langObj?.ItemType : ('ItemType' | translate)}}" [value]="element.itemtype">
          <mat-option *ngFor="let o of ItemType" [value]="o.itemTypeId">{{
            o.name
            }}</mat-option>
        </mat-select>
      </td>
    </ng-container>

    <ng-container matColumnDef="standard">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">{{langObj ? langObj?.Standard : ('Standard' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element;let i  = index">
        <textarea matInput cdkTextareaAutosize (change)="standardEvent($event, element, i)"
          placeholder="{{langObj ? langObj?.AddText : ('AddText' | translate)}}" #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1" cdkAutosizeMaxRows="7">{{ element.standard }}</textarea>
      </td>
    </ng-container>

    <ng-container matColumnDef="minimum">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">{{langObj ? langObj?.Min : ('Min' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element;let i  = index">

        <input matInput type="number" [disabled]="element.itemtype != 2" (change)="minEvent($event, element, i)"
          placeholder="{{langObj ? langObj?.AddValue : ('AddValue' | translate)}}" value="{{ element.minValue }}" />

      </td>
    </ng-container>

    <ng-container matColumnDef="maximum">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">{{langObj ? langObj?.Max : ('Max' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element;let i  = index">
        <input matInput type="number" [disabled]="element.itemtype != 2" (change)="maxEvent($event, element)"
          placeholder="{{langObj ? langObj?.AddValue : ('AddValue' | translate)}}" value="{{ element.maxValue }}" />
      </td>
    </ng-container>

    <ng-container matColumnDef="good">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">{{langObj ? langObj?.GoodExample : ('GoodExample' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="content-top-row"
          style="display: flex;justify-content: center; align-items: center; margin-left: -1rem;">

          <button mat-mini-fab
            *ngIf="(!formMode && element.goodExampleImageName.length > 0 && !element.HideViewIcon) && isAccess | permissionChecker"
            color="accent" (click)="openFilePopUp(element , i , 1)" style="background-color: #8f0fd1;">
            <mat-icon>remove_red_eye</mat-icon>
          </button>

          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width:7rem;margin-left: 5px;margin-top: 0;">
            <mat-label>{{langObj ? langObj?.AddFiles : ('AddFiles' | translate)}}</mat-label>
            <ngx-mat-file-input #fileInput
              style="white-space:nowrap;text-overflow: ellipsis; overflow: hidden; display:block;"
              (change)="uploadedFile($event,element, fileInput)"
              accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
              <mat-icon matSuffix>folder</mat-icon>
            </ngx-mat-file-input>
          </mat-form-field>
        </div>

      </td>
    </ng-container>

    <ng-container matColumnDef="bad" style="margin-left: 40px;">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="header-text">{{langObj ? langObj?.BadExample : ('BadExample' | translate)}}</p>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="content-top-row" style="display: flex; justify-content: center; align-items: center;">
          <button mat-mini-fab
            *ngIf="(!formMode  && element.badExampleImageName.length > 0 && !element.HideViewIcon1) && isAccess | permissionChecker"
            color="accent" (click)="openFilePopUp(element , i , 2)" style="background-color: #8f0fd1;">
            <mat-icon>remove_red_eye</mat-icon>
          </button>


          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 7rem;margin-left:5px;height: fit-content;">
            <mat-label>{{langObj ? langObj?.AddFiles : ('AddFiles' | translate)}}</mat-label>
            <ngx-mat-file-input #fileInput1
              style="white-space:nowrap;text-overflow: ellipsis; overflow: hidden; display:block;"
              (change)="uploadedFile2($event,element, fileInput1)"
              accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
              <mat-icon matSuffix>folder</mat-icon>
            </ngx-mat-file-input>
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" style="text-align: center" colspan="4">
        {{langObj ? langObj?.nodatamatch : ('nodatamatch' | translate)}}
      </td>
    </tr>
  </table>
  <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10]" showFirstLastButtons>
  </mat-paginator>
  <div mat-dialog-actions style="float: right; margin-top: 10px">
    <button (click)="addCheckList()" mat-mini-fab mat-button color="primary"
      *ngIf="formMode && isWrite | permissionChecker" matTooltip="{{langObj ? langObj?.Save : ('Save' | translate)}}"
      matTooltipClass="custom-tooltip" matTooltipPosition="above" style="margin-left: 20px;">
      <i class="fa fa-floppy-o" style="color: #fff"></i>
    </button>
    <button mat-mini-fab mat-button color="primary" [disabled]="isLoading || addtabledata.length === 0"
      *ngIf="!formMode && isUpdate | permissionChecker"
      matTooltip="{{langObj ? langObj?.Update : ('Update' | translate)}}" matTooltipClass="custom-tooltip"
      matTooltipPosition="above" style="margin-left: 20px;" (click)="updateCheckList()">
      <mat-icon *ngIf="!isLoading">edit</mat-icon>
      <mat-spinner color="accent" *ngIf="isLoading" diameter="20">
      </mat-spinner>
    </button>
  </div>
</form>


<!-- CHECKLIST GROUP MODEL -->
<ng-template #displayGroupModal>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{langObj ? langObj?.AddGroup : ('AddGroup' | translate)}}</h2>
      <button mat-mini-fab mat-button (click)="closeDisplayGroupModal()" color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>

  <form [formGroup]="AddGroupForm">
    <mat-dialog-content>
      <mat-form-field appearance="fill" class="field-fill inputs1">
        <mat-label>{{langObj ? langObj?.Group : ('Group' | translate)}}</mat-label>
        <input matInput placeholder="{{langObj ? langObj?.EnterGroupName : ('EnterGroupName' | translate)}}"
          formControlName="dropname" />
        <mat-error>{{langObj ? langObj?.Required : ('Required' | translate)}}</mat-error>
      </mat-form-field>
      <button type="submit" *ngIf="isWrite | permissionChecker" mat-mini-fab mat-button color="primary"
        (click)="SaveGroup()" [disabled]="!AddGroupForm.valid"
        matTooltip="{{langObj ? langObj?.Save : ('Save' | translate)}}" matTooltipClass="custom-tooltip"
        matTooltipPosition="above" style="margin-left: 20px;">
        <i class="fa fa-floppy-o" style="color: #fff"></i>
      </button>
    </mat-dialog-content>
  </form>
</ng-template>

<!-- CHECKLIST DROPDOWN MODEL -->
<ng-template #displayDropDownModal>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2 mat-dialog-title>{{langObj ? langObj?.AddDropdownElement : ('AddDropdownElement' | translate)}}</h2>
      <button mat-mini-fab mat-button (click)="closeDisplayDropDownModal()" color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <form [formGroup]="AddDropDownForm">
    <mat-dialog-content>
      <mat-form-field appearance="fill" class="field-fill inputs1">

        <mat-label>{{langObj ? langObj?.DropdownElement : ('DropdownElement' | translate)}}</mat-label>
        <input matInput placeholder="{{langObj ? langObj?.EnterElement : ('EnterElement' | translate)}}"
          formControlName="dropdown" />
        <mat-error>{{langObj ? langObj?.Required : ('Required' | translate)}}</mat-error>
      </mat-form-field>
      <button type="submit" *ngIf="isWrite | permissionChecker" mat-mini-fab mat-button color="primary"
        (click)="SaveDropDown()" [disabled]="!AddDropDownForm.valid"
        matTooltip="{{langObj ? langObj?.Save : ('Save' | translate)}}" matTooltipClass="custom-tooltip"
        matTooltipPosition="above" style="margin-left: 20px;">
        <i class="fa fa-floppy-o" style="color: #fff"></i>
      </button>
    </mat-dialog-content>
  </form>

  <mat-divider></mat-divider>
  <table mat-table [dataSource]="DropdownElemenet" class="mat-elevation-z8" style="width:100%">

    <!-- Position Column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef class="tbheader"> No. </th>
      <td mat-cell *matCellDef="let element;let i = index"> {{i+1}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef class="tbheader"> Value </th>
      <td mat-cell *matCellDef="let element"> {{element.value}} </td>
    </ng-container>
    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef class="tbheader">Actions</th>
      <td mat-cell *matCellDef="let element;let i = index">
        <span style="cursor: pointer;" (click)="deletedropDownById(element,i)">
          <mat-icon>delete</mat-icon>
        </span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [hidden]="row.IsActive === false && row.IsDeleted === true"></tr>

  </table>

</ng-template>

<p-dialog [closeOnEscape]="false" *ngIf="fileType=='doc'? true : false" header="File Detail"
  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '90vw'}" [maximizable]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <ngx-doc-viewer [url]="doc" viewer="google" style="width:100%;height:90vh;"></ngx-doc-viewer>
</p-dialog>
<p-dialog [closeOnEscape]="false" *ngIf="fileType=='img' ? true : false" header="File Detail"
  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '90vw'}" [maximizable]="true" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <angular-image-viewer [src]="images" [(index)]="imageIndexOne"></angular-image-viewer>
</p-dialog>